import _toConsumableArray from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var _process4, _process4$env;
var __jsx = React.createElement;
import '../themes/flexboxgrid.css';
import '../themes/global.css';
import React from 'react';
import GlobalStateProvider from '../global-state-context';
import withLinkValidation from '../utils/withLinkValidation';
import { NinetailedProvider } from '@ninetailed/experience.js-next';
import { NinetailedPreviewPlugin } from '@ninetailed/experience.js-plugin-preview';
import { NinetailedInsightsPlugin } from '@ninetailed/experience.js-plugin-insights';
import { ContentfulLivePreviewProvider } from "@contentful/live-preview/react";
import '@contentful/live-preview/style.css';
function MyApp(_ref) {
  var _process, _process$env, _process2, _process2$env, _process3, _process3$env, _pageProps$allExperie;
  var Component = _ref.Component,
    pageProps = _ref.pageProps;
  return __jsx(ContentfulLivePreviewProvider, {
    locale: "en-US",
    enableInspectorMode: ((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NEXT_PUBLIC_ENABLE_PREVIEW) === 'true',
    enableLiveUpdates: ((_process2 = process) === null || _process2 === void 0 ? void 0 : (_process2$env = _process2.env) === null || _process2$env === void 0 ? void 0 : _process2$env.NEXT_PUBLIC_ENABLE_PREVIEW) === 'true'
  }, __jsx(NinetailedProvider, {
    clientId: process.env.NEXT_PUBLIC_NINETAILED_CLIENT_ID,
    environment: process.env.NEXT_PUBLIC_NINETAILED_ENVIRONMENT,
    plugins: [new NinetailedInsightsPlugin()].concat(_toConsumableArray(((_process3 = process) === null || _process3 === void 0 ? void 0 : (_process3$env = _process3.env) === null || _process3$env === void 0 ? void 0 : _process3$env.NEXT_PUBLIC_ENABLE_PREVIEW) === 'true' ? [new NinetailedPreviewPlugin({
      audiences: ((_pageProps$allExperie = pageProps.allExperiences) === null || _pageProps$allExperie === void 0 ? void 0 : _pageProps$allExperie.map(function (experience) {
        return experience.audience;
      }).filter(function (audience) {
        return !!audience;
      })) || [],
      experiences: pageProps.allExperiences || [],
      onOpenAudienceEditor: function onOpenAudienceEditor(audience) {
        window.open("https://app.contentful.com/spaces/".concat(process.env.NEXT_PUBLIC_CONTENTFUL_API_SPACE_ID, "/environments/").concat(process.env.NEXT_PUBLIC_CONTENTFUL_API_ENVIRONMENT || 'master', "/entries/").concat(audience.id), '_blank');
      },
      onOpenExperienceEditor: function onOpenExperienceEditor(experience) {
        window.open("https://app.contentful.com/spaces/".concat(process.env.NEXT_PUBLIC_CONTENTFUL_API_SPACE_ID, "/environments/").concat(process.env.NEXT_PUBLIC_CONTENTFUL_API_ENVIRONMENT || 'master', "/entries/").concat(experience.id), '_blank');
      },
      ui: {
        opener: {
          hide: !process.env.NEXT_PUBLIC_ENABLE_PREVIEW
        }
      }
    })] : [])),
    componentViewTrackingThreshold: 2000,
    requestTimeout: 5000,
    url: "https://experience.ninetailed.co"
  }, __jsx(GlobalStateProvider, {
    initialData: pageProps
  }, __jsx(Component, pageProps))));
}
export default ((_process4 = process) === null || _process4 === void 0 ? void 0 : (_process4$env = _process4.env) === null || _process4$env === void 0 ? void 0 : _process4$env.NEXT_PUBLIC_ENABLE_PREVIEW) === 'true' ? withLinkValidation(MyApp) : MyApp;